/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getRestrictionSnapshots} from '../api'

 export const useQueryGetRestrictionSnapshots = createReactQueryHook('getRestrictionSnapshots', getRestrictionSnapshots)
